import { useCallback } from "react";
import { deleteFirebaseToken, getFirebaseToken } from "../firebase";
import { removePushToken } from "../services/notifications";

export const useSignOut = () => {
  const signOut = useCallback(async () => {
    try {
      const token = await getFirebaseToken();
      if (token) {
        await Promise.all([
          removePushToken(token),
          deleteFirebaseToken(),
        ]);
      }
    } catch (error) {
      console.error("Error getting FCM token during sign out:", error);
    } finally {
      localStorage.removeItem("xProfilePk");
      localStorage.removeItem("xUserRole");
      localStorage.removeItem("xAuthToken");
      localStorage.removeItem("xAuthRefreshToken");
      localStorage.removeItem("xShowMyClaims");
      localStorage.removeItem("xNotificationsEnabled");
      localStorage.removeItem("xLayout");
      localStorage.removeItem("xUserAuthType");
      localStorage.removeItem("xChatDrafts");
      localStorage.removeItem("xUserPinData");
      sessionStorage.removeItem("xUserPinEntered");
      window.location.replace("/sign_in/phone");
    }
  }, []);


  return signOut;
};
